export const data = {
    labels: ['Passed',"Failed"],
    datasets: [
      {
        label: 'Average Results over 60 %',
        data: [7 ,10],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
        ],
        borderWidth: 1,
        
      },
    ],
  };